import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles';
import {styles} from 'common/lib/styles';
import Badge from '@material-ui/core/Badge';
import ErrorIcon from '@material-ui/icons/Error';
import Tooltip from '@material-ui/core/Tooltip';
import { Condition } from './Condition';
import noImage from 'assets/images/no-image.png'
import {getRemainingLifetime} from 'client/lib/keyNumbers';
import {ReactComponent as NoteIcon} from 'assets/images/note-icon.svg'
class PartItem extends Component {

  render () {
    const {classes, project, linkHandler, part, md, prioritized} = this.props;
    const {images} = part;
    const imageUrl = images.length > 0
        ? `https://ik.imagekit.io/aw3ddey5g/${images[0].s3_image_id}?tr=w-223,h-167`
        : noImage
    return (
         <Grid item sm={12} md={md} className={classes.partGrid} onClick={ linkHandler }>
            <div className={classes.partAvatarContainer}>
                <Avatar className={classes.partAvatar} src={imageUrl} />
                <div className={classes.partAvatarTextContainer}>
                    <p className={classes.partAvatarLead}>{part.title}</p>
                    <p className={classes.partAvatarTitle}>{ project.title }</p>
                </div>
                {/* <div className={classes.prioritizedNotes}>
                    {part.notes.length ? <Tooltip PopperProps={{ style: { marginTop: -20 } }} title="Indeholder noter">
                        <NoteIcon className={classes.noteIcon}/>
                    </Tooltip> : null}
                </div> */}
            </div>
            {prioritized && <div className={classes.partLabel}>
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g>
                        <path d="M4.99578 0.896973C5.2046 0.896973 5.40971 0.952441 5.59013 1.05756C5.77057 1.1627 5.92011 1.3137 6.02307 1.49539H6.0228L9.35478 7.32628C9.45833 7.50564 9.51287 7.70918 9.51293 7.91629C9.51298 8.12336 9.45874 8.3269 9.35532 8.50629C9.25185 8.68573 9.10276 8.83499 8.92346 8.93869C8.7442 9.04235 8.5408 9.0969 8.33373 9.09711H1.66679V9.09684C1.4597 9.09818 1.25577 9.04539 1.0757 8.94304C0.894792 8.84019 0.744359 8.6912 0.639502 8.51145C0.534645 8.33168 0.479101 8.12739 0.478641 7.91927C0.478185 7.71115 0.532718 7.50652 0.636789 7.32628L3.96931 1.4943C4.07224 1.31313 4.2214 1.16249 4.40144 1.05756C4.58185 0.952436 4.78698 0.896986 4.99578 0.896973ZM4.99578 1.59142C4.90982 1.59143 4.82538 1.61433 4.7511 1.65761C4.67685 1.70089 4.61527 1.76296 4.57288 1.83773L4.57234 1.83881L1.239 7.67215L1.23819 7.6735C1.19535 7.74769 1.17292 7.83198 1.17309 7.91764C1.17327 8.00331 1.19613 8.08751 1.23927 8.16151C1.28243 8.23549 1.34441 8.29685 1.41885 8.33919C1.49335 8.38154 1.57785 8.40344 1.66354 8.40267H8.33292C8.4182 8.40258 8.50214 8.38027 8.57597 8.33757C8.64977 8.29488 8.71105 8.23346 8.75365 8.15962C8.79625 8.08574 8.8185 8.00184 8.81848 7.91656C8.81846 7.83127 8.79602 7.74737 8.75338 7.6735L8.75284 7.67215L5.4195 1.83881L5.41869 1.83773C5.3763 1.76297 5.31472 1.70087 5.24047 1.65761C5.16619 1.61434 5.08175 1.59142 4.99578 1.59142ZM5.00419 6.736C5.19593 6.736 5.35137 6.8915 5.35142 7.08323C5.35142 7.27499 5.19596 7.43045 5.00419 7.43045H5.00012C4.80836 7.43045 4.6529 7.27499 4.6529 7.08323C4.65295 6.8915 4.80839 6.736 5.00012 6.736H5.00419ZM4.6529 5.41656V3.74989C4.65295 3.55817 4.80839 3.40267 5.00012 3.40267C5.19181 3.40272 5.3473 3.5582 5.34735 3.74989V5.41656C5.34735 5.60829 5.19185 5.76373 5.00012 5.76378C4.80836 5.76378 4.6529 5.60832 4.6529 5.41656Z" fill="#C96F4A"/>
                    </g>
                </svg>
                Hurtigst muligt
            </div>}
        </Grid>
    )
  }
}


const mapStateToProps = state => {
  return {
    plan: state.data.customer.plan
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PartItem))
